import React, {useContext, useState} from "react";
import './PackingMaterial.css'
import axios from 'axios';
import {RoundNumber} from "../CommonComponents/CommonFunctions";
import {Elink, UpdatePackingMaterialsUrl} from '../CommonComponents/Routes'
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import swal from 'sweetalert';

export default (props) => {//this component is used to manage or show packing materials.
    let total_price = 0,
        total_qty = 0,
        [selectValue, setSelectValue] = useState(''),
        list = {},
        HasEditPermission = props.Functionality === 'Manage',
        CompanyPackingMaterials = {},
        RecordsManagement = useContext(RecordsManagementContext),
        ViewManagement = useContext(ViewMangementContext),
        Currency = RecordsManagement.CP_PageDetails.Currency


    //fetched the packing materials added for the estimate
    RecordsManagement.CP_PageDetails.PackingMaterials.List.map((pack_material) => {
        list[pack_material.Id] = {
            Id: pack_material.Id,
            Name: pack_material.Name,
            Qty: pack_material.Qty,
            Price: pack_material.Price,
            PackingMaterialId: pack_material.PackingMaterialId
        }
        total_price += pack_material.TotalPrice
        total_qty += pack_material.Qty
    })

//here we fetched the company packing materials so from these packing material options customer can choose packing material
    RecordsManagement.CP_PageDetails.PackingMaterials.CompanyMaterials.map((pack_material) => {
        CompanyPackingMaterials[pack_material.Id] = {
            Id: pack_material.Id,
            Name: pack_material.Name,
            Qty: pack_material.Qty,
            Price: pack_material.Price,
        }
    })

    const [PackMaterialsStructure, setPackMaterialsStructure] = useState({
        List: list,
        TotalPrice: total_price,
        TotalQty: total_qty,
        NewMaterialCount: 0
    })

    //this is used to add packing materials if isAlreadyExist = false then it will add new packing material in list(PackingMaterialslist)
    // otherwise it will update quantity of the packing material
    const AddNewPackingMaterial = (value) => {
        if (value !== '') {
            let PackingMaterialslist = PackMaterialsStructure.List,
                total_qty = PackMaterialsStructure.TotalQty,
                total_price = PackMaterialsStructure.TotalPrice,
                isAlreadyExist = false,
                materialId = 0,
                COMPANY_PACK_MATERIAL = CompanyPackingMaterials[value],
                COUNT = PackMaterialsStructure.NewMaterialCount
            Object.entries(PackingMaterialslist).map(([id, PackingMaterial]) => {
                if (PackingMaterial.PackingMaterialId === parseInt(value)) {
                    isAlreadyExist = true
                    materialId = id
                }
            })
            if (isAlreadyExist === true && materialId !== 0) {
                PackingMaterialslist[materialId].Qty += COMPANY_PACK_MATERIAL.Qty
            } else if (isAlreadyExist === false && materialId === 0) {
                let id = 'NewPackingMaterial' + COUNT
                PackingMaterialslist[id] = {
                    Id: id,
                    Name: COMPANY_PACK_MATERIAL.Name,
                    Qty: COMPANY_PACK_MATERIAL.Qty,
                    Price: COMPANY_PACK_MATERIAL.Price,
                    PackingMaterialId: COMPANY_PACK_MATERIAL.Id
                }
                COUNT += 1
            }
            total_qty += COMPANY_PACK_MATERIAL.Qty
            total_price += COMPANY_PACK_MATERIAL.Qty * COMPANY_PACK_MATERIAL.Price
            setPackMaterialsStructure({
                List: PackingMaterialslist,
                TotalPrice: total_price,
                TotalQty: total_qty,
                NewMaterialCount: COUNT
            })
        } else {
            ViewManagement.setAlertProperty({
                                    Message: 'Please select any one Packing Material to Add new Packing Material.',
                                    Type: 'warning',
                                    Show: true,
                                    AutoHide: true
                                })
        }
    }

    const RemovePackingMaterial = (id) => {
        if (id !== "clear-all"){
            let PackingMaterialslist = PackMaterialsStructure.List,
                total_qty = PackMaterialsStructure.TotalQty,
                total_price = PackMaterialsStructure.TotalPrice,
                COUNT = PackMaterialsStructure.NewMaterialCount
            total_price -= PackingMaterialslist[id].Price * PackingMaterialslist[id].Qty
            total_qty -= PackingMaterialslist[id].Qty
            delete PackingMaterialslist[id]
            setPackMaterialsStructure({
                List: PackingMaterialslist,
                TotalPrice: total_price,
                TotalQty: total_qty,
                NewMaterialCount: COUNT
            })
        }else {
            let PackingMaterialslist = PackMaterialsStructure.List
            if (Object.keys(PackingMaterialslist).length === 0) {
                 swal({
                    text: "No packing materials added!",
                    icon: "error"
                });
            }else {
                 swal({
                    title: "Are you sure?",
                    text: "Once deleted, you will not be able to recover this packing materials!",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                }).then((willDelete) => {
                    if (willDelete) {
                        Object.entries(PackingMaterialslist).map(([id, PackingMaterial]) => {
                            delete PackingMaterialslist[id]
                        });
                        setPackMaterialsStructure({
                            List: PackingMaterialslist,
                            TotalPrice: 0.00,
                            TotalQty: 0,
                            NewMaterialCount: 0
                        })
                        //  swal("Your packing materials has been deleted!", {
                        //     icon: "success",
                        // });
                    }
                });
            }
        }
    }

//handle increase and decrease in the quantity of the packing materials
    const ChangeQty = (id, type) => {
        let PackingMaterialslist = PackMaterialsStructure.List,
            material_price = PackingMaterialslist[id].Price,
            total_qty = PackMaterialsStructure.TotalQty,
            total_price = PackMaterialsStructure.TotalPrice,
            COUNT = PackMaterialsStructure.NewMaterialCount
        type === 'Decrement' ? PackingMaterialslist[id].Qty -= 1 : PackingMaterialslist[id].Qty += 1
        type === 'Decrement' ? total_qty -= 1 : total_qty += 1
        type === 'Decrement' ? total_price -= Number(material_price) : total_price += Number(material_price)
        if (PackingMaterialslist[id].Qty === 0) {
            delete PackingMaterialslist[id]
        }
        setPackMaterialsStructure({
            List: PackingMaterialslist,
            TotalPrice: total_price,
            TotalQty: total_qty,
            NewMaterialCount: COUNT
        })
    }

    // these buttons are for increasing or decreasing packing material quantity
    const ChngQtyBtn = (props) => {
        const {test} = props
        if (HasEditPermission) {
            return (
                <button
                    disabled={test == 0}
                    className={props.For === '+' ? ' ' +
                        'btn btn-primary btn-sm increase-decrease-btn plus-bt' : ' ' +
                        'btn btn-primary btn-sm increase-decrease-btn minus-bt'}
                    id={props.Id}
                    onClick={() => {
                        ChangeQty(props.Id, props.For === '+' ? 'Increment' : 'Decrement')
                    }}>
                    {props.For}
                </button>
            )
        } else {
            return ''
        }
    }

    //increase or decrease the quantity of the material manually.
    const ChangeQtyFor = (NewValue, id , OldValue ) => {
        NewValue = isNaN(NewValue) ? 0 : NewValue
        let type = NewValue > OldValue ? "Increment" : "Decrement"
        let value = NewValue > OldValue ? NewValue - OldValue : OldValue - NewValue
        let PackingMaterialslist = PackMaterialsStructure.List,
            material_price = PackingMaterialslist[id].Price * value,
            total_qty = PackMaterialsStructure.TotalQty,
            total_price = PackMaterialsStructure.TotalPrice,
            COUNT = PackMaterialsStructure.NewMaterialCount
        PackingMaterialslist[id].Qty = NewValue
        type === 'Decrement' ? total_qty -= value : total_qty += value
        type === 'Decrement' ? total_price -= Number(material_price) : total_price += Number(material_price)
        if (PackingMaterialslist[id].Qty === 0) {
            delete PackingMaterialslist[id]
        }
        setPackMaterialsStructure({
            List: PackingMaterialslist,
            TotalPrice: total_price,
            TotalQty: total_qty,
            NewMaterialCount: COUNT
        })
    }

    const PackingMaterialQty = (props) => {
        return (
            <>
                <ChngQtyBtn For={'-'} Id={props.Id} test={props.Qty}/>
                {HasEditPermission ?
                    <input type="text" pattern="[0-9]*" className='packing-nm' defaultValue={props.Qty}
                           onKeyUp={(e)=> e.target.validity.valid ? "" : ChangeQtyFor( parseInt(props.Qty), props.Id, parseInt(props.Qty) ) }
                           onBlur={(e)=> ChangeQtyFor( parseInt(e.target.value), props.Id, parseInt(props.Qty) )}></input>
                    : props.Qty}
                <ChngQtyBtn For={'+'} Id={props.Id}/>
            </>
        )
    }
//update the packing materials (added or updated) on the backend  (api hit goes to moveitpro and handle updates)
    const update_packing_materials_qty = (hash) => {
        let cookie = document.cookie.split('employee_id=')[1]
        axios({
            method: 'post', url: UpdatePackingMaterialsUrl,
            params: {
                estimate_key: Elink,
                employee_key: cookie,
                packing_materials_hash: hash
            }
        }).then((response) => {
            {
                let Message = response.data.Message
                //shows the success message if packing material will update successfully.
                ViewManagement.setAlertProperty({
                    Message: Message.Text,
                    Type: Message.Type,
                    Show: true,
                    AutoHide: true
                })
                if(Message && Message.Text === "Expired Link"){
                    window.location.reload();
                }
                else if (Message.Status == undefined) {
                    RecordsManagement.SetCP_PageDetails({
                        ...RecordsManagement.CP_PageDetails,
                        PackingMaterials: response.data

                    })
                }
                ViewManagement.setModalContent({Title: '', Body: '', Class: ''})
            }
        })
    }
 // this button will shown if estimate is not booked
    let UpdateButton = HasEditPermission ?
        <button className="btn btn-primary" data-dismiss="modal"
                onClick={() => update_packing_materials_qty(PackMaterialsStructure.List)}>
            Update
        </button> : ''
    return (
        <>
            <div className='pack-mat-body'>
                {Object.keys(PackMaterialsStructure.List).length > 0 ?
                    <table className={`table mb-0 estimated-cost-tbl description packing-material ${HasEditPermission ? "manage-packing-tbl" : "show-packing-tbl"}`}  >
                        <thead>
                        <tr>
                            <th >Material</th>
                            <th className="cost-head" >Cost</th>
                            <th >Quantity</th>
                        </tr>
                        </thead>
                    <tbody>
                    <div style={{maxHeight: "25rem", overflowX: "hidden", overflowY: "auto", paddingRight: "10px" }}>
                        {Object.entries(PackMaterialsStructure.List).map(([id, PackingMaterial]) => {
                            return (
                                <tr key={id + 'tr1'}>
                                    <td data-label="Material"  key={id + 'td1'}>{PackingMaterial.Name}</td>
                                    <td data-label="Cost" key={id + 'td2'}>{Currency}{PackingMaterial.Price}</td>
                                    <td className="equal-line" data-label="Quantity">
                                        <div className="number-count" key={id + 'td3'}>
                                            <PackingMaterialQty Id={PackingMaterial.Id} Qty={PackingMaterial.Qty}/>
                                            {HasEditPermission ?
                                                <button type="button" className="delete-bt" style={{marginTop: "7%",
                                                    marginLeft: "1rem"}}
                                                        onClick={() => RemovePackingMaterial(PackingMaterial.Id)}>X</button> : ""}
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </div>
                    </tbody>
                    </table> : <b>No records available - Add New Packing Materials!</b>}
                {HasEditPermission ? <div className='row mt-3'>
                    <div className="col">
                        <select className="custom-select" style={{marginLeft: "25%", height: "100%" }} id="NewPackingMaterail"
                                onChange={(e) => AddNewPackingMaterial(e.target.value)}
                                value={selectValue}>
                            <option disabled value="">Select Packing Material</option>
                            {Object.entries(CompanyPackingMaterials).map(([id, packing_material]) => {
                                return (
                                    <option key={id} value={id}>{packing_material.Name}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="col float-right">
                        <button className='btn btn-danger btn-sm' style={{marginLeft: "30%", height: "100%" }} onClick={() => RemovePackingMaterial("clear-all")}>Clear All</button>
                    </div>
                </div> : ''}
            </div>
            <div className='pack-mat-body border-top'>
                <h6>Total Items: {PackMaterialsStructure.TotalQty}</h6>
                <h5>Estimated Materials Cost: {Currency}{RoundNumber(PackMaterialsStructure.TotalPrice)}</h5>
            </div>
            <div className='pack-mat-body update-bn text-center border-top'>
                {UpdateButton}
            </div>
        </>
    )
}